import { Button } from "@corpuscomplete/web-ui/components/button";
import { PlannedMealCalendar } from "@corpuscomplete/core-ui/nutrition/planned-meal/calendar";

export function PlannedMealsWeekStrip({
  days,
  focusedDate,
  onSelectDate,
}: {
  days: readonly PlannedMealCalendar.WeekStripDay[];
  focusedDate: Temporal.PlainDate;
  onSelectDate: (date: Temporal.PlainDate) => void;
}) {
  return (
    <div className="grid grid-cols-7 gap-2">
      {days.map((day) => {
        const active = day.date.equals(focusedDate);
        return (
          <Button
            key={day.date.toString()}
            variant={active ? "default" : "outline"}
            className="h-auto flex-col items-start gap-1 py-2"
            onClick={() => onSelectDate(day.date)}
          >
            <span className="text-[0.625rem] uppercase opacity-70">
              {day.date.toLocaleString("en-US", { weekday: "short" })}
            </span>
            <span className="text-sm">{day.date.day}</span>
            <span className="h-4 text-[0.625rem] opacity-80">
              {day.count === 0 ? "" : day.count === 1 ? "1 meal" : `${day.count} meals`}
            </span>
          </Button>
        );
      })}
    </div>
  );
}
